export const getIsAchievementsEnabled = (achievementsEnabled?: boolean) =>
  achievementsEnabled ?? false;

export const getIsUploadPractiseSectionEnabled = (
  uploadPractiseSectionEnabled?: boolean
) => uploadPractiseSectionEnabled ?? false;

export const getIsUploadActivitySheetEnabled = (
  uploadActivitySheetEnabled?: boolean
) => uploadActivitySheetEnabled ?? false;

export const getIsChatEnabled = (chatEnabled?: boolean) => chatEnabled ?? false;

export const getIsLessonAudioEnabled = (lessonAudioEnabled?: boolean) =>
  lessonAudioEnabled ?? false;

export const getIsLessonImageEnlargementEnabled = (
  lessonImageEnlargementEnabled?: boolean
) => lessonImageEnlargementEnabled ?? false;

// BLD2-209: Resume recent work feature — hardcoded off until ready for release
export const getIsResumeRecentWorkEnabled = (): boolean => false;

// BLD2-363: Assignment submission panel — off until submission slices are ready
export const getIsAssignmentSubmitPanelEnabled = (
  assignmentSubmitPanelEnabled?: boolean
) => assignmentSubmitPanelEnabled ?? false;
